<template>
  <b-row class="no-gutters">
    <b-col sm="12" xl="8">
      <b-card>
        <template slot="header">
          {{ uid ? 'Account Details' : 'New Account' }}
          <b-badge v-if="uid" class="border ml-3 bg-white text-muted">
            {{ account.id }}
          </b-badge>
        </template>
        <b-form>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="Name">
                <b-form-input
                  :disabled="Boolean(uid !== 'new')"
                  type="text"
                  v-model="account.name"
                  required
                  placeholder="Name">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Email">
                <b-form-input
                  type="text"
                  v-model="account.email"
                  required
                  placeholder="Email">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group
                label="Permissions">
                <mulselect
                  :options="permOptions"
                  :values="account.permissions"
                  :limit="10">
                </mulselect>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Approval Emails">
                <toggle-button
                  v-model="account.approval_emails"
                  :sync="true"
                  color="#2bd879">
                </toggle-button>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="text-right">
            <b-btn @click="save()" variant="primary">Save</b-btn>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
    import {AccountsApi} from '@/accounts/api'
    import Mulselect from '@/components/Mulselect'
    import auth from '@/auth'

    export default {
        props: {
            uid: {required: true},
            cid: {required: false}
        },
        data() {
            return {
                account: {
                    permissions: ['LOGIN'],
                    approval_emails: true,
                    company_id: this.cid,
                    id: this.userId
                },
                permOptions: {
                    'BILLING': 'Billing',
                    'TECHNICAL': 'Technical',
                    'LOGIN': 'Login'
                }
            }
        },
        created() {
            if(this.userId) {
                AccountsApi.accountDetails(this.userId).then((details) => {
                    this.account = details
                })
            }

            if(auth.isAdmin()) {
              this.permOptions.ADMIN = 'Admin'
              this.permOptions.SUPER_ADMIN = 'Super Admin'
            }
        },
        computed: {
            userId () {
                return this.uid !== 'new' ? this.uid : null
            }
        },
        methods: {
            save() {
                AccountsApi.accountSet(this.account).then((data) => {
                    this.$notify.success('Account saved')
                    if(!this.userId) {
                        this.$router.go(-1)
                    }
                }, (err) => {
                    this.$notify.error(err)
                })
            }
        },
        components: {
            Mulselect
        }
    }
</script>



// WEBPACK FOOTER //
// src/accounts/pages/Account.vue